import { collection, getDocs } from "firebase/firestore";
import { useCallback, useEffect, useState } from "react";

import { db } from "integrations/firebase/firestore";

export type DomainAllowlistState =
  | { status: "loading" }
  | { status: "error"; error: string }
  | { status: "success"; data: string[] };

export function useDomainAllowlist(): DomainAllowlistState & {
  reload: () => void;
} {
  const [state, setState] = useState<DomainAllowlistState>({
    status: "loading",
  });
  const [tick, setTick] = useState(0);

  useEffect(() => {
    let cancelled = false;

    // No setState("loading") here: a reload keeps the current list on screen
    // rather than replacing the whole section with skeletons.
    getDocs(collection(db, "domain_allowlist"))
      .then((snap) => {
        if (cancelled) return;
        const domains: string[] = [];
        snap.forEach((d) => domains.push(d.id));
        domains.sort();
        setState({ status: "success", data: domains });
      })
      .catch((err) => {
        if (cancelled) return;
        setState({
          status: "error",
          error:
            err instanceof Error
              ? err.message
              : "Failed to load domain allowlist",
        });
      });

    return () => {
      cancelled = true;
    };
  }, [tick]);

  const reload = useCallback(() => setTick((t) => t + 1), []);

  return { ...state, reload };
}
